export default {
    name: "Ribbons",
    key: "Var_Ribbons",
    variables: [
        "ribbonTextColor",
        "ribbonPromotion",
        "ribbonBestRated",
        "ribbonNewProduct",
        "ribbonRecommendedProduct",
        "filterIcons",
        "ribbonPromotionalProduct",
        "ribbonVendorRecomendation",
        "ribbonGreatPrice",
        "ribbonGreatQuality",
        "ribbonSale",
        "ribbonReward",
    ]
}